// THIS IS A GENERATED FILE
import * as Types from "../../../graphql/types"

import {
  StructuredLogFieldsFragment,
  BuildActivityFieldsFragment,
} from "../../shared/fragments.generated"
import gql from "graphql-tag"
import {
  StructuredLogFieldsFragmentDoc,
  BuildActivityFieldsFragmentDoc,
} from "../../shared/fragments.generated"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type StructuredLogsForBuildQueryVariables = Types.Exact<{
  buildId: Types.Scalars["UUID"]
  siteId: Types.Scalars["UUID"]
  logLevel: Types.StructuredLogLevel
}>

export type StructuredLogsForBuildQuery = { __typename?: "Query" } & {
  structuredLogsForBuild?: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: "StructuredLog" } & Pick<Types.StructuredLog, "id"> & {
            activity?: Types.Maybe<
              { __typename?: "BuildActivity" } & BuildActivityFieldsFragment
            >
          } & StructuredLogFieldsFragment
      >
    >
  >
}

export type StructuredLogUpdatedSubscriptionVariables = Types.Exact<{
  activityId: Types.Scalars["UUID"]
}>

export type StructuredLogUpdatedSubscription = {
  __typename?: "Subscription"
} & {
  structuredLogUpdated?: Types.Maybe<
    { __typename?: "StructuredLog" } & {
      activity?: Types.Maybe<
        { __typename?: "BuildActivity" } & BuildActivityFieldsFragment
      >
    } & StructuredLogFieldsFragment
  >
}

export type StructuredLogCreatedSubscriptionVariables = Types.Exact<{
  buildId: Types.Scalars["UUID"]
}>

export type StructuredLogCreatedSubscription = {
  __typename?: "Subscription"
} & {
  structuredLogCreated?: Types.Maybe<
    { __typename?: "StructuredLog" } & {
      activity?: Types.Maybe<
        { __typename?: "BuildActivity" } & BuildActivityFieldsFragment
      >
    } & StructuredLogFieldsFragment
  >
}

export const StructuredLogsForBuildDocument = gql`
  query StructuredLogsForBuild(
    $buildId: UUID!
    $siteId: UUID!
    $logLevel: StructuredLogLevel!
  ) {
    structuredLogsForBuild(
      buildId: $buildId
      siteId: $siteId
      logLevel: $logLevel
    ) {
      id
      ...structuredLogFields
      activity {
        ...buildActivityFields
      }
    }
  }
  ${StructuredLogFieldsFragmentDoc}
  ${BuildActivityFieldsFragmentDoc}
`

/**
 * __useStructuredLogsForBuildQuery__
 *
 * To run a query within a React component, call `useStructuredLogsForBuildQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuredLogsForBuildQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredLogsForBuildQuery({
 *   variables: {
 *      buildId: // value for 'buildId'
 *      siteId: // value for 'siteId'
 *      logLevel: // value for 'logLevel'
 *   },
 * });
 */
export function useStructuredLogsForBuildQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StructuredLogsForBuildQuery,
    StructuredLogsForBuildQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    StructuredLogsForBuildQuery,
    StructuredLogsForBuildQueryVariables
  >(StructuredLogsForBuildDocument, baseOptions)
}
export function useStructuredLogsForBuildLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StructuredLogsForBuildQuery,
    StructuredLogsForBuildQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    StructuredLogsForBuildQuery,
    StructuredLogsForBuildQueryVariables
  >(StructuredLogsForBuildDocument, baseOptions)
}
export type StructuredLogsForBuildQueryHookResult = ReturnType<
  typeof useStructuredLogsForBuildQuery
>
export type StructuredLogsForBuildLazyQueryHookResult = ReturnType<
  typeof useStructuredLogsForBuildLazyQuery
>
export type StructuredLogsForBuildQueryResult = ApolloReactCommon.QueryResult<
  StructuredLogsForBuildQuery,
  StructuredLogsForBuildQueryVariables
>
export const StructuredLogUpdatedDocument = gql`
  subscription StructuredLogUpdated($activityId: UUID!) {
    structuredLogUpdated(activityId: $activityId) {
      ...structuredLogFields
      activity {
        ...buildActivityFields
      }
    }
  }
  ${StructuredLogFieldsFragmentDoc}
  ${BuildActivityFieldsFragmentDoc}
`

/**
 * __useStructuredLogUpdatedSubscription__
 *
 * To run a query within a React component, call `useStructuredLogUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStructuredLogUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredLogUpdatedSubscription({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useStructuredLogUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    StructuredLogUpdatedSubscription,
    StructuredLogUpdatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    StructuredLogUpdatedSubscription,
    StructuredLogUpdatedSubscriptionVariables
  >(StructuredLogUpdatedDocument, baseOptions)
}
export type StructuredLogUpdatedSubscriptionHookResult = ReturnType<
  typeof useStructuredLogUpdatedSubscription
>
export type StructuredLogUpdatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  StructuredLogUpdatedSubscription
>
export const StructuredLogCreatedDocument = gql`
  subscription StructuredLogCreated($buildId: UUID!) {
    structuredLogCreated(buildId: $buildId) {
      ...structuredLogFields
      activity {
        ...buildActivityFields
      }
    }
  }
  ${StructuredLogFieldsFragmentDoc}
  ${BuildActivityFieldsFragmentDoc}
`

/**
 * __useStructuredLogCreatedSubscription__
 *
 * To run a query within a React component, call `useStructuredLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStructuredLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredLogCreatedSubscription({
 *   variables: {
 *      buildId: // value for 'buildId'
 *   },
 * });
 */
export function useStructuredLogCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    StructuredLogCreatedSubscription,
    StructuredLogCreatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    StructuredLogCreatedSubscription,
    StructuredLogCreatedSubscriptionVariables
  >(StructuredLogCreatedDocument, baseOptions)
}
export type StructuredLogCreatedSubscriptionHookResult = ReturnType<
  typeof useStructuredLogCreatedSubscription
>
export type StructuredLogCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  StructuredLogCreatedSubscription
>
